  export const dashboardListingConfig = 
  {
    // "_id" : ObjectId("64cb9d29527d495688747a08"),
    "template_name" : "signdesk",
    "type" : "default",
    "wf_configuration_id" : "64cb989b527d4956885aa864",
    "wf_name" : "signdesk-test-dashboard-detail",
    "config_type" : "dashboard_listing",
    "is_deleted" : false,
    // "organisation_id" : ObjectId("64bfaca761c520f7aeab67e6"),
    "module_id" : "63b5326c5f0c894cfb1becba",
    "created_by" : null,
    "created_at" : "2023-01-24T10:27:44.074Z",
    "add_customer" : "app/signdesk-test",
    // "role_id" : ObjectId("64cb90e6527d4956883179d5"),
    "assign_to_roles" : [ 
        "64cb90e6527d4956883179d5"
    ],
    "fields" : [ 
        {
            "name" : "Name of the applicant",
            "id" : "full_name",
            "order" : 1,
            "datatype" : "text",
            "icon" : "icon-name",
            "db_column" : "name",
            "show" : "true",
            "custom_style" : "position-sticky start-0 z-index-2 bg-white",
            "extra_fields" : [ 
                "application_ref_id", 
                "link", 
                "profile_color_code", 
                "workflow_id", 
                "active_step"
            ]
        }, 
        {
            "name" : "Status",
            "id" : "status",
            "order" : 2,
            "datatype" : "dropdown",
            "icon" : "icon-status",
            "db_column" : "status",
            "show" : "true",
            "custom_style" : ""
        }, 
        {
            "name" : "Internal POC",
            "id" : "internal_poc",
            "order" : 3,
            "datatype" : "dropdown",
            "icon" : "icon-internal_poc",
            "db_column" : "popover-dropdown",
            "type" : "popover_dropdown",
            "show" : "false",
            "disabled" : "!(selectedData?.assign_poc)",
            "custom_style" : "",
            "value_key" : "internal_poc",
            "options_key" : "internalPocUsers"
        }, 
        {
            "name" : "Email ID",
            "id" : "email",
            "order" : 4,
            "datatype" : "text",
            "icon" : "icon-email_id",
            "db_column" : "email_id",
            "show" : "true",
            "custom_style" : ""
        }, 
        {
            "name" : "Contact details",
            "id" : "mobile_number",
            "order" : 5,
            "datatype" : "text",
            "icon" : "icon-contact_details",
            "db_column" : "contact_details",
            "custom_style" : "",
            "show" : "true"
        }, 
        {
            "name" : "Created At",
            "id" : "formatted_created_at",
            "order" : 6,
            "datatype" : "dropdown",
            "icon" : "icon-created_at",
            "db_column" : "created_at",
            "show" : "true",
            "custom_style" : ""
        }, 
        {
            "name" : "",
            "id" : "icon",
            "order" : 15,
            "datatype" : "icon",
            "icon" : "icon-plus",
            "db_column" : "icon",
            "show" : "true",
            "type" : "popover",
            "trigger_when" : "click",
            "custom_style" : "position-sticky end-0  bg-white",
            "list_items" : [ 
                {
                    "label" : "Send reminder",
                    "id" : "send_remainder",
                    "action" : "send_remainder",
                    "show" : "selectedData?.edit == true"
                }, 
                {
                    "label" : "Edit",
                    "id" : "edit_workflow",
                    "action" : "edit_workflow",
                    "show" : "selectedData?.edit == true"
                }, 
                {
                    "label" : "View Application",
                    "id" : "view_application",
                    "action" : "view_application",
                    "show" : "true"
                }, 
                {
                    "label" : "Delete",
                    "id" : "delete_workflow",
                    "action" : "delete_workflow",
                    "show" : "selectedData?.delete == true",
                    "confirmation_content" : {
                        "heading" : "Delete applicant",
                        "content" : "Are you sure you want to delete this applicant?",
                        "form_buttons" : [ 
                            {
                                "label" : "Back",
                                "action" : "back"
                            }, 
                            {
                                "label" : "Confirm",
                                "action" : "next"
                            }
                        ]
                    }
                }
            ]
        }
    ],
    "sidebar_structure" : {
        "list_items" : [ 
            {
                "name" : "Application",
                "module_name" : "low_code_dashboard",
                "module_id" : "63b5326c5f0c894cfb1becba",
                "detail_view_module_id" : "63b5327e5f0c894cfb1bf14f"
            }, 
            {
                "name" : "Dealer Application",
                "module_id" : "643fb548e1bef57b56dd7a1f",
                "module_name" : "low_code_dashboard_signdesk_applications",
                "detail_view_module_id" : "643faed6f8029df1d04cfb5c"
            }
        ]
    }
}

